import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HeaderLogo from './HeaderLogo.react';
import HeaderButtons from './HeaderButtons.react';

export default class Header extends Component {
  render() {
    return (
      <header className='header' role='banner'>
        <HeaderLogo
          logoFile={this.props.logoFile}
          organizationName={this.props.organizationName}
        />
        <p>
          <HeaderButtons viewerMode={this.props.viewerMode} />
          {this.props.organizationName}
        </p>
      </header>);
  }
}

Header.propTypes = {
  logoFile: PropTypes.string.isRequired,
  organizationName: PropTypes.string.isRequired,
  viewerMode: PropTypes.bool.isRequired,
};
